import React from "react";

const SvgCarsQueue = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 30 20" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="CarsQueue_svg__a"
        d="M1214.855 637.837v7.409l-.017 2.451c0 .68-.556 1.289-1.235 1.289h-1.092c-.68 0-1.235-.68-1.235-1.36v-2.22h-14.317v2.22c0 .68-.537 1.36-1.217 1.36h-1.11c-.68 0-1.234-.609-1.234-1.289l-.018-9.86 2.56-7.356c.268-.716.93-1.181 1.753-1.181h12.867c.806 0 1.486.465 1.736 1.181zm-19.007-1.372h16.556l-1.843-5.376h-12.87zm1.114 5.366c.987 0 1.794-.807 1.794-1.794 0-.986-.807-1.793-1.794-1.793-.986 0-1.793.807-1.793 1.793 0 .987.807 1.794 1.793 1.794zm14.31 0c.987 0 1.794-.807 1.794-1.794 0-.986-.807-1.793-1.793-1.793-.987 0-1.794.807-1.794 1.793 0 .987.807 1.794 1.794 1.794z"
      />
      <path
        id="CarsQueue_svg__b"
        d="M1191.877 637.835v-.219l.071-.207.258-.74h-1.163l1.623-4.724h1.183l.548-1.575h-1.731c-.725 0-1.308.41-1.544 1.04l-2.252 6.472.016 8.678c0 .598.488 1.133 1.086 1.133h.977c.412 0 .765-.284.944-.657z"
      />
      <path
        id="CarsQueue_svg__c"
        d="M1187.306 638.115v-.168l.055-.158.197-.568h-.891l1.244-3.623h.908l.42-1.208h-1.328c-.556 0-1.003.314-1.184.797l-1.727 4.964.012 6.655c0 .459.375.87.833.87h.75c.316 0 .586-.219.724-.505z"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#CarsQueue_svg__a"
      transform="translate(-1185 -629)"
    />
    <use
      fill="currentColor"
      xlinkHref="#CarsQueue_svg__b"
      transform="translate(-1185 -629)"
    />
    <use
      fill="currentColor"
      xlinkHref="#CarsQueue_svg__c"
      transform="translate(-1185 -629)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgCarsQueue svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/CarsQueue.js